import React from "react"
import { Field, useField } from "formik"
import { FormContext } from "../Form"
import cx from "classnames"

const Checkbox = ({ children, name, required = false }) => {
  const [value] = useField(name)

  return <FormContext.Consumer>
    {({ negative }) => {
      return <Field name={name} validate={(value) => {
        if (required && !value) {
          return required
        }
      }}>
        {({ field, meta, form }) => {
          const error = (meta.touched || form.submitCount > 0) && meta.error
          return <div className="grid gap-1" style={{ gridTemplateColumns: "24px auto" }}>
            <input
              {...field}
              type={"checkbox"}
              checked={value.value}
              className={cx("input-checkbox h-3 w-3 grid rounded place-content-center border-2 cursor-pointer bg-transparent", {
                "checked:bg-blue-10 checked:border-blue-10 ": !negative,
                "checked:bg-blue-10 checked:border-blue-10 border-midnight-50": !negative
              })}
            />
            <div className={cx("inline text-small", { "text-midnight-60": negative, "text-midnight-10": !negative, })}>
              {children}{required ? "*" : ""}
            </div>
            {error && <div className="text-[#EA344A] mt-0.5 col-span-2 text-small">{error}</div>}
          </div>
        }}
      </Field>
    }}
  </FormContext.Consumer >
}

export default Checkbox